module.exports = __webpack_public_path__ + "img/b2c-logo.6c89c97a.png";